export const getThermalReceiptTemplate = (
  cart,
  customer,
  storeInfo,
  selectedPaymentMethod,
  paidAmount,
  receiptNumber,
  discount = null,
  customVATRate = null
) => {
  console.log('🧾 Generating Thermal Receipt with store info:', storeInfo);
  console.log('💰 Discount:', discount);
  console.log('📊 Custom VAT Rate:', customVATRate);

  const subtotal = cart.reduce((sum, item) => sum + item.Quantity * item.Price, 0);
  
  const discountAmount = discount?.amount || 0;
  const totalAfterDiscount = Math.max(0, subtotal - discountAmount);
  
  const totalVAT = cart.reduce((sum, item) => {
    const itemTotal = item.Quantity * item.Price;
    const itemRatio = subtotal > 0 ? itemTotal / subtotal : 0;
    const itemDiscountedTotal = itemTotal - (discountAmount * itemRatio);
    const vatRate = customVATRate !== null && customVATRate !== undefined ? customVATRate : item.VAT;
    return sum + ((itemDiscountedTotal * vatRate) / 100);
  }, 0);
  
  const totalIncl = totalAfterDiscount + totalVAT;
  const change = (parseFloat(paidAmount) || 0) - totalIncl;

  const vatBreakdown = {};
  cart.forEach((item) => {
    const vatRate = customVATRate !== null && customVATRate !== undefined 
      ? customVATRate 
      : parseFloat(item.VAT || 0);
    const itemTotal = item.Quantity * item.Price;
    const itemRatio = subtotal > 0 ? itemTotal / subtotal : 0;
    const itemDiscountedTotal = itemTotal - (discountAmount * itemRatio);
    const vatAmount = (itemDiscountedTotal * vatRate) / 100;

    if (!vatBreakdown[vatRate]) {
      vatBreakdown[vatRate] = { base: 0, vat: 0 };
    }
    vatBreakdown[vatRate].base += itemDiscountedTotal;
    vatBreakdown[vatRate].vat += vatAmount;
  });

  let vatSectionHtml = '';
  Object.keys(vatBreakdown).forEach((rate) => {
    const { base, vat } = vatBreakdown[rate];
    vatSectionHtml += `
      <tr>
        <td style="padding: 2px 0; font-weight: 900;">VAT ${rate}%:</td>
        <td style="text-align: right; font-weight: 900;">€${base.toFixed(2)}</td>
        <td style="text-align: right; font-weight: 900;">€${vat.toFixed(2)}</td>
      </tr>
    `;
  });

  const vatIndicator = customVATRate !== null && customVATRate !== undefined && customVATRate !== 21
    ? `<p style="font-size: 11px; color: #000; font-weight: 900;">⚠️ Custom VAT Rate Applied: ${customVATRate}%</p>`
    : '';

  const companyName = storeInfo?.name || storeInfo?.Name || storeInfo?.CompanyName || 'Your Company Name';
  const companyAddress = storeInfo?.address || storeInfo?.Address || (storeInfo?.Street && storeInfo?.StreetNumber ? `${storeInfo.Street} ${storeInfo.StreetNumber}` : '') || '123 Street Address';
  const companyCity = storeInfo?.city || storeInfo?.City || 'City';
  const companyPostCode = storeInfo?.postCode || storeInfo?.PostCode || '';
  const companyCityFull = companyPostCode ? `${companyPostCode} ${companyCity}` : companyCity;
  const companyCountry = storeInfo?.country || storeInfo?.Country || '';
  const companyPhone = storeInfo?.phone || storeInfo?.Phone || storeInfo?.PhoneNumber || '+32 123 456 789';
  const companyVAT = storeInfo?.vat || storeInfo?.VATNumber || storeInfo?.BTWNumber || storeInfo?.TaxNumber || 'BE 0123.456.789';
  const companyEmail = storeInfo?.email || storeInfo?.Email || '';
  const companyWebsite = storeInfo?.website || storeInfo?.Website || '';

  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <style>
        @page {
          size: 80mm auto;
          margin: 0;
        }
        html, body {
          height: auto;
          margin: 0;
          padding: 0;
        }
        @media print {
          body {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
            color-adjust: exact;
          }
          * {
            -webkit-font-smoothing: none;
            -moz-osx-font-smoothing: grayscale;
          }
        }
        * { 
          margin: 0; 
          padding: 0; 
          box-sizing: border-box; 
        }
        body {
          font-family: 'Courier New', Courier, monospace;
          font-size: 13px;
          line-height: 1.4;
          color: #000;
          background: white;
          padding: 10px;
          width: 80mm;
          font-weight: 700;
          -webkit-font-smoothing: none;
          -moz-osx-font-smoothing: grayscale;
        }
        .receipt-container { 
          width: 100%; 
        }
        .header { 
          text-align: center; 
          margin-bottom: 15px; 
          border-bottom: 2px dashed #000; 
          padding-bottom: 10px; 
        }
        .header h1 { 
          font-size: 20px; 
          font-weight: 900; 
          margin-bottom: 5px;
          letter-spacing: 1px;
        }
        .header p { 
          font-size: 11px; 
          margin: 2px 0; 
          line-height: 1.3;
          font-weight: 700;
        }
        .header strong {
          font-weight: 900;
        }
        .info-section { 
          margin: 10px 0; 
          font-size: 12px;
          font-weight: 700;
        }
        .info-row { 
          display: flex; 
          justify-content: space-between; 
          margin: 3px 0;
          font-weight: 700;
        }
        .info-row strong {
          font-weight: 900;
        }
        table { 
          width: 100%; 
          border-collapse: collapse; 
          margin: 10px 0;
          table-layout: fixed;
        }
        th { 
          text-align: left; 
          border-bottom: 2px solid #000; 
          padding: 5px 2px; 
          font-size: 11px;
          font-weight: 900;
        }
        th:first-child { width: 45%; }
        th:nth-child(2) { width: 15%; }
        th:nth-child(3) { width: 20%; }
        th:nth-child(4) { width: 20%; }
        td { 
          padding: 5px 2px; 
          font-size: 11px;
          font-weight: 700;
          word-wrap: break-word;
          word-break: break-word;
          overflow-wrap: break-word;
        }
        .item-row td { 
          border-bottom: 1px dotted #000; 
        }
        .total-section { 
          margin-top: 15px; 
          border-top: 2px solid #000; 
          padding-top: 10px; 
        }
        .total-row { 
          display: flex; 
          justify-content: space-between; 
          margin: 5px 0; 
          font-weight: 800;
          font-size: 12px;
        }
        .discount-row {
          background: #000;
          color: #fff;
          padding: 5px;
          margin: 5px 0;
          border: 2px solid #000;
          font-weight: 900;
        }
        .discount-label {
          font-size: 11px;
          font-weight: 900;
        }
        .after-discount {
          background: #000;
          color: #fff;
          padding: 5px;
          margin: 5px 0;
          font-weight: 900;
          font-size: 12px;
        }
        .grand-total { 
          font-size: 17px;
          font-weight: 900;
          margin-top: 10px;
          padding-top: 5px;
          border-top: 3px double #000;
        }
        .savings-banner {
          text-align: center;
          background: #000;
          color: #fff;
          padding: 8px;
          margin: 10px 0;
          font-weight: 900;
          font-size: 12px;
        }
        .footer { 
          text-align: center; 
          margin-top: 20px; 
          border-top: 2px dashed #000; 
          padding-top: 10px; 
          font-size: 11px;
          font-weight: 700;
        }
        .footer p {
          font-weight: 700;
        }
        .footer strong {
          font-weight: 900;
        }
        .payment-info { 
          margin: 10px 0; 
          padding: 10px; 
          background: #000; 
          color: #fff;
          border: 2px solid #000;
          font-weight: 800;
        }
        .payment-info .total-row {
          color: #fff;
          font-size: 12px;
        }
        .vat-indicator {
          background: #000;
          color: #fff;
          padding: 5px;
          margin: 5px 0;
          border: 2px solid #000;
          text-align: center;
          font-size: 10px;
          font-weight: 900;
        }
        strong, b {
          font-weight: 900 !important;
        }
      </style>
    </head>
    <body>
      <div class="receipt-container">
        <div class="header">
          <h1>TICKET DE CAISSE</h1>
          <p><strong>${companyName}</strong></p>
          <p>${companyAddress}</p>
          <p>${companyCityFull}${companyCountry ? ', ' + companyCountry : ''}</p>
          <p>Tel: ${companyPhone}</p>
          <p>TVA: ${companyVAT}</p>
          ${companyWebsite ? `<p>${companyWebsite}</p>` : ''}
          ${vatIndicator ? `<div class="vat-indicator">${vatIndicator}</div>` : ''}
        </div>

        <div class="info-section">
          <div class="info-row">
            <span>Receipt #:</span>
            <span><strong>${receiptNumber}</strong></span>
          </div>
          <div class="info-row">
            <span>Date:</span>
            <span><strong>${new Date().toLocaleDateString('fr-BE')} ${new Date().toLocaleTimeString('fr-BE', { hour: '2-digit', minute: '2-digit' })}</strong></span>
          </div>
          ${customer ? `
            <div class="info-row">
              <span>Client:</span>
              <span><strong>${customer.Name || 'N/A'}</strong></span>
            </div>
          ` : ''}
          <div class="info-row">
            <span>Cashier:</span>
            <span><strong>Admin</strong></span>
          </div>
        </div>

        <table>
          <thead>
            <tr>
              <th style="width: 45%;">Product</th>
              <th style="width: 15%; text-align: center;">Qty</th>
              <th style="width: 20%; text-align: right;">Price</th>
              <th style="width: 20%; text-align: right;">Total</th>
            </tr>
          </thead>
          <tbody>
            ${cart.map(item => `
              <tr class="item-row">
                <td style="width: 45%; word-wrap: break-word;"><strong>${item.Name || 'N/A'}</strong></td>
                <td style="width: 15%; text-align: center;"><strong>${item.Quantity}</strong></td>
                <td style="width: 20%; text-align: right;"><strong>€${item.Price.toFixed(2)}</strong></td>
                <td style="width: 20%; text-align: right;"><strong>€${(item.Quantity * item.Price).toFixed(2)}</strong></td>
              </tr>
            `).join('')}
          </tbody>
        </table>

        <div class="total-section">
          <div class="total-row">
            <span><strong>Subtotal (Excl. VAT):</strong></span>
            <span><strong>€${subtotal.toFixed(2)}</strong></span>
          </div>
          
          ${discount ? `
          <div class="discount-row">
            <div style="display: flex; justify-content: space-between;">
              <div>
                <span class="discount-label">DISCOUNT ${discount.type === 'percentage' ? `(${discount.value}%)` : ''}</span>
                ${discount.reason ? `<br><span style="font-size: 10px; font-weight: 900;">${discount.reason}</span>` : ''}
              </div>
              <span class="discount-label">-€${discountAmount.toFixed(2)}</span>
            </div>
          </div>
          <div class="after-discount">
            <div style="display: flex; justify-content: space-between;">
              <span><strong>After Discount:</strong></span>
              <span><strong>€${totalAfterDiscount.toFixed(2)}</strong></span>
            </div>
          </div>
          ` : ''}
          
          <table style="font-size: 11px; margin: 10px 0;">
            <thead>
              <tr>
                <th style="font-weight: 900;">VAT Rate</th>
                <th style="text-align: right; font-weight: 900;">Base</th>
                <th style="text-align: right; font-weight: 900;">VAT Amount</th>
              </tr>
            </thead>
            <tbody>
              ${vatSectionHtml}
            </tbody>
          </table>

          <div class="total-row">
            <span><strong>Total VAT:</strong></span>
            <span><strong>€${totalVAT.toFixed(2)}</strong></span>
          </div>
          
          <div class="total-row grand-total">
            <span><strong>TOTAL (Incl. VAT):</strong></span>
            <span><strong>€${totalIncl.toFixed(2)}</strong></span>
          </div>
        </div>

        ${discount ? `
        <div class="savings-banner">
          ★ YOU SAVED €${discountAmount.toFixed(2)} ★
        </div>
        ` : ''}

        <div class="payment-info">
          <div class="total-row">
            <span><strong>Payment Method:</strong></span>
            <span><strong>${selectedPaymentMethod}</strong></span>
          </div>
          ${paidAmount ? `
            <div class="total-row">
              <span><strong>Paid:</strong></span>
              <span><strong>€${parseFloat(paidAmount).toFixed(2)}</strong></span>
            </div>
            <div class="total-row">
              <span><strong>Change:</strong></span>
              <span><strong>€${change.toFixed(2)}</strong></span>
            </div>
          ` : ''}
        </div>

        <div class="footer">
          <p><strong>*** THANK YOU FOR YOUR VISIT ***</strong></p>
          <p><strong>Keep this receipt for exchanges and returns</strong></p>
          ${discount ? `<p style="margin-top: 5px; font-weight: 900;">Discount saved you €${discountAmount.toFixed(2)}</p>` : ''}
          ${companyWebsite ? `<p><strong>${companyWebsite}</strong></p>` : ''}
        </div>
      </div>
    </body>
    </html>
  `;
};